var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-7532.33,-298.473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chevron_right-black",
    transform: "matrix(0.145417,0,0,0.186342,7128.81,239.431)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2774.96,
    y: 316.846,
    width: 220.057,
    height: 171.727,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.87679,0,0,5.36648,-49023.3,-1284.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7552.28,314.473L7542.97,323.777C7542.71,324.037 7542.71,324.46 7542.97,324.72C7543.23,324.98 7543.66,324.98 7543.92,324.72L7553.69,314.945L7553.7,314.932L7553.72,314.92C7553.87,314.751 7553.92,314.523 7553.87,314.315L7553.86,314.299L7553.86,314.283L7553.85,314.268L7553.85,314.253L7553.84,314.237L7553.84,314.222L7553.83,314.207L7553.82,314.192L7553.82,314.178L7553.81,314.163L7553.8,314.149L7553.79,314.134L7553.79,314.12L7553.78,314.106L7553.77,314.092L7553.76,314.079L7553.75,314.065L7553.74,314.052L7553.73,314.039L7553.72,314.027L7553.7,314.014L7553.69,314.002C7553.69,314.002 7543.92,304.226 7543.92,304.226C7543.66,303.966 7543.23,303.966 7542.97,304.226C7542.71,304.486 7542.71,304.909 7542.97,305.169L7552.28,314.473Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.87f43c75e665e00e9f5fe8f80476a5d8.svg";
export { ForwardRef as ReactComponent };